import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/index/Home.vue'

const routes = [
  {
    path: '/',
    redirect:(to) => ({ path:'/taskList', query: to.query })
  },
  {
    path: '/taskList',
    name: 'TaskList',
    // 路由级代码分割
    component: () => import('../views/task/TaskList.vue')
  },
  {
    path: '/myTask',
    name: 'MyTask',
    // 路由级代码分割
    component: () => import('../views/task/MyTask.vue')
  },
  {
    path: '/taskInfo',
    name: 'TaskInfo',
    component: () => import('../views/task/TaskInfo.vue')
  },
  {
    path: '/shensuInfoXzb',
    name: 'ShensuInfoXzb',
    component: () => import('../views/task/shensuInfoXzb.vue')
  },
  {
    path: '/shensuTask',
    name: 'ShensuTask',
    component: () => import('../views/task/shensuTask.vue')
  },
  {
    path: '/tixian',
    name: 'TixianView',
    component: () => import('../views/money/tixian.vue')
  },
  {
    path: '/qianbao',
    name: 'MoneyView',
    component: () => import('../views/money/money.vue')
  },
  {
    path: '/shoukuan-info',
    component: () => import('../views/money/shoukuan-info-view.vue')
  },
  {
    path: '/tixian-success',
    name:"TixianSuccess",
    component: () => import('../views/money/tixian-success.vue')
  }

]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router